import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useEffect, useState, useRef} from 'react';
import uniqid from 'uniqid';


function Work() {

    const laRef = useRef(null);
    const cosRef = useRef(null);
    const grRef = useRef(null);

    const [work, setWork] = useState([

         {
            title: 'The Odin Project',
            date: 'September 2020 - Present',
            contributions: [
                'Developed and maintained code primarily using HTML, CSS, Sass, and JavaScript',
                'Manually tested sites in various browsers and mobile devices to ensure cross-browser compatibility and responsiveness',
                '1/2+ years of JavaScript experience, including concepts of asynchronous programming, closures, types, and ES6',
                '1/2+ years of HTML/CSS experience, Responsive Web Design, including concepts like layout, specificity, cross browser compatibility, and accessibility.',
                '1/2+ years of experience with browser APIs and optimizing front end performance.',
                'Demonstrated experience of coding, development, testing with variety of tech stacks.'
            ],
            status: true,
            id: uniqid(),
            tag: 'gr'

        },
         {
            title: 'freeCodeCamp',
            date: 'August - September 2020',
            contributions: [
                'Recognized as a Responsive Web Design expert.',
                'Earned certification on Data structures and Algorithm',
            ],
            status: false,
            id: uniqid(),
            tag: 'cos'
        },
        {
            title: 'Creative Technologist Co-op',
            date: 'January - December 2016',
            contributions: [
                'Write modern, performant, maintainable code for a diverse array of client and internal projects',
                'Work with a variety of different languages, platforms, frameworks, and content management systems such as JavaScript, TypeScript, Gatsby, React, Craft, WordPress, Prismic, and Netlify',
                'Communicate with multi-disciplinary teams of engineers, designers, producers, and clients on a daily basis',
            ],
            status: false,
            id: uniqid(),
            tag: 'la'
        },
    ])

    const handleClick = (e, value) => {
        work.map(item => {
            item.status = false;
        })
        grRef.current.style.borderLeft = '';
        grRef.current.style.color = '';
        grRef.current.style.background = '';

        setWork([...work].map(object => {
            if(object.tag === value) {
              return {
                ...object,
                status: !false,
              }
            }
            else return object;
          }))
    }

    
    const xpHistory = work.map((item, i) => {
        if(item.status) {
            return(
               <div key={item.id} className='work-div'>
                    <span className='job-title'>{item.title}</span>
                    <span className='job-date'>{item.date}</span>
                    <div className='skills-core'>
                    {
                        item.contributions.map((item, i) => {
                            return(
                                <div key={i} className='work-contbtn'>
                                    <div>
                                        <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                                    </div>
                                    <div>{item}</div>
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
            )
        }
    });

    useEffect ( () => {
        grRef.current.style.borderLeft = '2px solid rgba(22,224,189,1)'
        grRef.current.style.color = 'rgba(22,224,189,1)'
        grRef.current.style.background = 'rgba(17,34,64,1)'
    }, [])

    return (
        <div className='history'>
            <h3  className='work-header'>Work Experience</h3>
            <div className='xp-div'>
                <div className='xp-bar-div'>
                        <button className={work[0].status ? 'is-active' : 'square-button'} ref={grRef} onClick={ (e) => handleClick(e,'gr')}>
                            TOP
                        </button>
                        <button className={work[1].status ? 'is-active' : 'square-button'} ref={cosRef} onClick={ (e) => handleClick(e,'cos')}>
                            freeCodeCamp
                        </button>
                        {/* <button className={work[2].status ? 'is-active' : 'square-button'} ref={laRef} onClick={ (e) => handleClick(e,'la')}>
                            Toptal
                        </button > */}
                </div>
                <div>
                    {xpHistory}
                </div>
            </div>
            
        </div>
    )
}

export default Work
